module.exports = __webpack_public_path__ + "img/F_image15.a508006b.jpg";